import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import Select from 'react-select';
import { API_URL } from '..';

const AddStaffLayer = () => {
    const [imagePreviewUrl, setImagePreviewUrl] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);
    const [message, setMessage] = useState({
        status: false,
        reason: '',
        desc: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreviewUrl(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleChangeRole = (selected) => {
        setSelectedValue(selected || null);
    };

    const onFormSubmission = async (event) => {
        event.preventDefault();
        setMessage({ status: false, reason: '', desc: '' });

        const formData = {
            name: event.target.elements.name.value,
            email: event.target.elements.email.value,
            password: event.target.elements.password.value,
            confirmPassword: event.target.elements.confirmPassword.value,
            phone: event.target.elements.phone.value,
            role: selectedValue?.value
        };

        // Client-side validation
        if (!formData.name) {
            setMessage({ status: true, reason: 'error', desc: 'Name is required' });
            return;
        }
        if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email)) {
            setMessage({ status: true, reason: 'error', desc: 'Valid email is required' });
            return;
        }
        if (!formData.password) {
            setMessage({ status: true, reason: 'error', desc: 'Password is required' });
            return;
        }
        if (formData.password !== formData.confirmPassword) {
            setMessage({ status: true, reason: 'error', desc: 'Passwords do not match' });
            return;
        }
        if (!formData.role) {
            setMessage({ status: true, reason: 'error', desc: 'Role is required' });
            return;
        }

        setIsSubmitting(true);
        try {
            let headerList = {
                'Accept': '*/*',
                'Content-type': 'application/json'
            };
            let bodyContent = JSON.stringify({
                name: formData.name,
                email: formData.email,
                password: formData.password,
                role: formData.role,
                phone: formData.phone
            });
            const response = await fetch(`${API_URL}/api/user/create`, {
                method: 'POST',
                body: bodyContent,
                headers: headerList
            });
            const data = await response.json();
            if (response.status === 201) {
                setMessage({ status: true, reason: 'success', desc: 'Staff added successfully' });
                event.target.reset();
                setSelectedValue(null);
                setImagePreviewUrl('');
            } else {
                throw new Error(data.message || 'Failed to add staff');
            }
        } catch (error) {
            setMessage({ status: true, reason: 'error', desc: `Failed to add staff: ${error.message}` });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-body p-24">
                <div className="row justify-content-center">
                    <div className="col-xxl-6 col-xl-8 col-lg-10">
                        <div className="card border">
                            <div className="card-body">
                                {/* Message Alert */}
                                {message.status && (
                                    <div className={`alert alert-${message.reason === 'error' ? 'danger' : 'success'} alert-dismissible fade show mb-20`} role="alert">
                                        {message.desc}
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setMessage({ ...message, status: false })}
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                )}

                                {/* Form */}
                                <form onSubmit={onFormSubmission}>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="name"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Full Name <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="name"
                                            name="name"
                                            placeholder="Enter Full Name"
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="email"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Email <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="email"
                                            className="form-control radius-8"
                                            id="email"
                                            name="email"
                                            placeholder="Enter email address"
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="number"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Phone
                                        </label>
                                        <input
                                            type="tel"
                                            className="form-control radius-8"
                                            id="number"
                                            name="phone"
                                            placeholder="Enter phone number"
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="role"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Select Role <span className="text-danger-600">*</span>
                                        </label>
                                        <Select
                                            options={[
                                                { label: 'Admin', value: 'admin' },
                                                { label: 'User', value: 'user' },
                                               
                                            ]}
                                            placeholder="Select Role"
                                            value={selectedValue}
                                            onChange={handleChangeRole}
                                            classNamePrefix="select"
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="password"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Password <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="password"
                                            className="form-control radius-8"
                                            id="password"
                                            name="password"
                                            placeholder="*******"
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="confirmPassword"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Confirm Password <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="password"
                                            className="form-control radius-8"
                                            id="confirmPassword"
                                            name="confirmPassword"
                                            placeholder="*******"
                                        />
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <button
                                            type="submit"
                                            className="btn btn-primary border border-primary-400 text-md px-56 py-12 radius-8"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? 'Submitting...' : 'Submit'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddStaffLayer;